import React from 'react';
import classnames from 'classnames';
import { Svg } from 'src/components/Svg/Svg';
import { BADGES_TIPS } from 'src/constants/product';
import { useIsIrishUser } from 'src/util/cookies';

import classes from './PriceBadge.scss';

type Props = {
    isBundle?: boolean;
    isNoPriceAbove?: boolean;
    isInTieredPricing?: boolean;
    price?: number;
    showDpdAndReturnsBadges?: boolean;
    showBestPrice?: boolean;
};

export const PriceBadge: React.FC<Props> = ({ isBundle, isNoPriceAbove, isInTieredPricing, showBestPrice }) => {
    const isIrishUser = useIsIrishUser();

    const badge = (badgeName: string) => {
        const element = BADGES_TIPS.find((badge) => badge.name === badgeName);
        if (!element) return null;

        return (
            <>
                <img src={require(`../../../static/img/${element.img}`)} alt={element.tip} data-img={element.tip} />
                <div className={classes.badgesInformations}>
                    <p>{element.tip}</p>
                    <p>{element.information}</p>
                </div>
            </>
        );
    };

    return (
        <div
            className={classnames(classes.productDetailPriceBadge, {
                [classes.productDetailPriceBadgeNoPrice]: isNoPriceAbove,
                [classes.productDetailPriceBadgeInTieredPricing]: isInTieredPricing,
                [classes.isBundle]: isBundle,
            })}
        >
            {isBundle ? (
                <span>
                    <Svg name="star" className={classnames(classes.productDetailPriceBadgeStar, classes.isBundle)} />
                    price, checked & guaranteed
                </span>
            ) : (
                <span className={classes.badges}>
                    {showBestPrice ? (
                        <div className={classes.bestPrice}>{badge('bestPrice')}</div>
                    ) : (
                        <div className={classes.priceGuaranteed}>{badge('priceGuaranteed')}</div>
                    )}
                    <div
                        className={classnames(classes.supplyingBadge, {
                            [classes.supplyingBadgeCentered]: isIrishUser,
                        })}
                    >
                        {!isIrishUser && (
                            <span className={classes.supplyingFlag}>
                                <img src={require('src/components/Svg/svgs/uk-flag.svg')} alt="UK flag" />
                            </span>
                        )}
                        <div className={classes.badgesInformations}>
                            <p>Supplying 1.2M businesses</p>
                        </div>
                    </div>
                </span>
            )}
        </div>
    );
};
